/* ─────────────────────────────────────────────────────────────
   pethealth main.js · vanilla JS only
   - Brand bar mobile dropdown toggle
   - Comparison-table sticky-header observer
   - Lightbox + responsive video kept from Source baseline
   ───────────────────────────────────────────────────────────── */

/* ── Brand-bar mobile dropdown ─────────────────────────────── */
(function () {
    const bar    = document.getElementById('site-header');
    const toggle = document.querySelector('[data-brand-bar-toggle]');
    if (!bar || !toggle) return;

    function setOpen(open) {
        bar.dataset.open = open ? 'true' : 'false';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
        setOpen(bar.dataset.open !== 'true');
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && bar.dataset.open === 'true') {
            setOpen(false);
            toggle.focus({ preventScroll: true });
        }
    });
})();

/* ── Comparison table: sticky header on scroll ─────────────── */
(function () {
    const tables = document.querySelectorAll('.gear-comparison-table');
    if (!tables.length || !('IntersectionObserver' in window)) return;

    tables.forEach(function (tbl) {
        const sentinel = document.createElement('div');
        sentinel.className = 'gear-comparison-table__sentinel';
        sentinel.setAttribute('aria-hidden', 'true');
        tbl.parentNode.insertBefore(sentinel, tbl);

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                tbl.classList.toggle('is-stuck', !entry.isIntersecting && entry.boundingClientRect.top < 0);
            });
        }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });

        observer.observe(sentinel);
    });
})();

/* ── Add lightbox to gallery images (kept from Source) ─────── */
(function () {
    if (typeof lightbox !== 'function') return;
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* ── Responsive video in post content (kept from Source) ──── */
(function () {
    if (typeof reframe !== 'function') return;
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* ── Responsive HTML table wrap (kept from Source) ─────────── */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* ── Infinite scroll (kept from Source for archive pages) ──── */
(function () {
    if (typeof pagination !== 'function') return;
    if (!document.body.classList.contains('home-template') &&
        !document.body.classList.contains('post-template')) {
        pagination();
    }
})();
